module.exports = __webpack_public_path__ + "static/media/bolsa-de-dinheiro.79da2c5f.png";